import { render } from "./CommunicationDraftContainer.vue?vue&type=template&id=a39bd99a&scoped=true&ts=true"
import script from "./CommunicationDraftContainer.vue?vue&type=script&lang=ts"
export * from "./CommunicationDraftContainer.vue?vue&type=script&lang=ts"

import "./CommunicationDraftContainer.vue?vue&type=style&index=0&id=a39bd99a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a39bd99a"]])

export default __exports__